module.exports = __webpack_public_path__ + "assets/img/advice.119ecb80.png";